<div [title]="tooltip" data-bs-placement="bottom" data-bs-toggle="tooltip">
  <span>
    <img alt="icon" height="14" src="assets/icons/info.svg" width="14"/>
  </span>
</div>
